import { render, staticRenderFns } from "./healthTestForm.vue?vue&type=template&id=3d5f475e&scoped=true&"
import script from "./healthTestForm.vue?vue&type=script&lang=js&"
export * from "./healthTestForm.vue?vue&type=script&lang=js&"
import style0 from "./healthTestForm.vue?vue&type=style&index=0&id=3d5f475e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f475e",
  null
  
)

export default component.exports